//Confirmation Modal, combines all other confirmation modals
define(function (require) {
	const tpl = require('civicsViews/favoriteContacts/add_favorite_modal/t_itv_add_favorites_modal.hbs');   
	const Utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'selected-favorites list-row',
		attributes: {
			'role': 'row'
		},
		modelEvents: {
			change: 'render',
		},
		events: {
			'click @ui.deleteButton': 'onDelete'
		},
		ui: {
			capacityType:'.capacity-type',
			applicantType:'.applicant-type',
			deleteButton: '.remove-selected'

		},
		initialize: function (options) {
			this.config = options.config;
			this.collection = options.collection;
			this.selectedFavorites = options.selectedFavorites;
			this.additionalCapacityTypes = options.additionalCapacityTypes;
			this.applicantTypes = options.applicantTypes;

		},
		onShow: function () {

		},
		//copied from cpv_add_applicant.js by getting the applicant and capacity types values
		getData: function () {
			let data = Backbone.Syphon.serialize(this);
			data = _.extend(data, Utils.serializeDroppy(this.$el));

			// Initial processing for capacity
			if (data.capacity) {
				const desc = Utils.civicsDropdownText(this.ui.capacityType);
				data.capacity = { code: data.capacity, description: desc };
			} else {
				let capacityCode = "";
				let capacityDesc = "";

				if (this.additionalCapacityTypes && this.additionalCapacityTypes.length === 1) {
					capacityCode = this.additionalCapacityTypes[0].code;
					capacityDesc = this.additionalCapacityTypes[0].description;
				}

				data.capacity = { code: capacityCode, description: capacityDesc };
			}

			// Process contactType
			if (data.contactType != null) {
				const applType = data.contactType;
				data.contactType = Utils.getApplicantType(this.config.instrumentType, applType);
			}
			//TradeLicense must have ApplicantType set to 1
			if(this.config.instrumentType.toLowerCase() == 'tradelicense'){
				data.contactType = "1";
			}
			if (data.contactType) {
				const desc = Utils.civicsDropdownText(this.ui.applicantType);
				data.contactTypeDescription = desc;
			} else {
				data.contactTypeDescription = {code:""};

				// Default the applicant type if not shown
				if (!this.config.showApplicantType) {
					const type = this.config.instrumentType?.toLowerCase();
					if (type === "tradelicense") {
						data.contactType = 2;
					} else if (type === "businesslicense") {
						data.contactType =  1;
					} else {
						data.contactType = 4 ;
					}
				}
			}

			// Perform validation
			const validation = this.validateData(data);
			data.isValid = validation.isValid;

			if (!data.isValid) {
				ViewManager.errorToWindow({ validationError: validation.errors }, this);
			}

			return data;
		},
		validateData: function (data) {
			const errors = {};
			let isValid = true;

			if (!data.capacity?.code && this.config.showCapacity && this.config.requireCapacity) {
				errors['capacity'] = i18n.t('CIVICS.FAVORITES.DIALOG.CAPACITY_REQUIRED');
				isValid = false;
			}

			if (!data.contactType && this.config.showApplicantType) {
				errors['contactType'] = i18n.t('CIVICS.FAVORITES.DIALOG.APPLICANT_TYPE_REQUIRED');
				isValid = false;
			}

			return { isValid, errors };
		},
		onRender: function () {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		onDelete: function () {
			this.model.set('removeFromSelected', true);

		},

		templateHelpers:function(){
			return {
				config: this.config,
				additionalCapacityTypes: this.additionalCapacityTypes ? this.additionalCapacityTypes.toJSON() : '',
				applicantTypes: this.applicantTypes ? this.applicantTypes.toJSON() : '',
				showCapacity: (this.config.showCapacity && this.additionalCapacityTypes && this.additionalCapacityTypes.length > 1) ? true : false,
				showApplicantType: function() {
					if (this.config.instrumentType.toLowerCase() == "tradelicense") {
						return false;
					}

					return this.config.showApplicantType;
                },
				name: this.model.get('firstName') + ' ' + this.model.get('lastName')

			}
		},
	});
});
